<template>
  <div v-loading="!favoriteRecipes">
    <div v-if="favoriteRecipes && favoriteRecipes.length >0 ">
      <div v-for="recipe in recipesInPage" v-bind:key="recipe.Id">
        <recipe-card @selectRecipe="handleSelectRecipe" shadow="never" :recipe="recipe"/>
        <br>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="favoriteRecipes.length * 3"
      ></el-pagination>
    </div>
    <div v-else>
      <p>No Favorite Recipes yet...</p>
    </div>
  </div>
</template>

<script>
import RecipeCard from '@/components/recipes/RecipeCard'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    ...mapGetters(['favoriteRecipes']),
    recipesInPage() {
      if (!this.favoriteRecipes) return []
      const recipesPerPage = 3
      const startOfRecipes = recipesPerPage * (this.currentPage - 1)
      const endOfRecipes = recipesPerPage * this.currentPage
      return this.favoriteRecipes.slice(startOfRecipes, endOfRecipes)
    }
  },
  methods: {
    handleSelectRecipe() {},
    handleCurrentChange(selected) {
      this.currentPage = selected
    }
  },
  components: {
    RecipeCard
  }
}
</script>

<style>
</style>
